import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useDialogFormStore } from '@/components/dialog/form.store';
import { PointsRequestData } from '@/services/pointsRequest/pointsRequest.types';
import { PointRequestForm } from '../../point-setup-forms/PointsRequestForm';
import { getColumns } from './Column';
import { useDynamicLocale } from '@/hoslog-intl';

export function PointsRequestTable({ data }: { data: PointsRequestData[] }) {
  const { onOpen } = useDialogFormStore();
  const { t } = useDynamicLocale();

  const columns = React.useMemo(() => getColumns(t), [t]);
  const onAddnew = () => {
    onOpen({
      modalTitle: null,
      title: t('pointManagement.sidebar.menu.pointsRequest'),
      okText: t('common.page.modal.confirm'),
      size: 'lg',
      cancelText: t('common.page.modal.no'),
      component: <PointRequestForm />,
    });
  };
  const { table } = useDataTable({
    data,
    columns,
    pageCount: 0,
    initialState: {
      sorting: [{ id: 'id', desc: true }],
    },
    meta: {
      title: t('pointManagement.sidebar.menu.pointsRequest'),
      action: onAddnew,
    },
    getRowId: (originalRow: PointsRequestData) => String(originalRow.id),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
